<template>
  <div class="home">
    <div class="h_banner max-width">
      <!-- 广告图片 -->
      <!-- <img v-for='item in banners' :key='item.id' :id="banners[banners_index]['id']" class='h_banner_img' :src="banners[banners_index]['url']" mode='widthFix'/> -->
      <img
        :id="banners[banners_index]['id']"
        class="h_banner_img"
        :src="banners[banners_index]['url']"
      />

      <!-- 面板指示点 -->
      <div class="h_banner_indicator">
        <template v-for="(item, index) in banners">
          <div
            :key="item.id"
            :class="{
              h_banner_indi_point: true,
              h_banner_indi_point_choose: item.choose,
            }"
            :data-index="index"
            @click="func_indicator"
          ></div>
        </template>
      </div>

      <!-- 登录窗口 -->
      <div v-if="!isLogin" class="h_banner_login">
        <div class="h_banner_login_title font-24 fontweight-bo color">
          账号登录
        </div>
        <div class="h_banner_login_li_toubu" >
          <img v-if="this.$parent.isorder" class="h_banner_login_li_toubu"  src="@/assets/icon/toubu.png" />
        </div>
        <!-- 账号 -->
        <div class="h_banner_login_line">
          <div class="h_banner_login_border">
            <img
              class="h_banner_login_li_icon"
              src="@/assets/icon/login_username.png"
            />
          </div>
          <input
            class="h_banner_login_li_input"
            data-type="username"
            placeholder="会员号/手机号"
            v-model="minilogin['username']"
            @blur="miniloginChange"
            @keyup.enter="func_login"
          />
        </div>
        <!-- 密码 -->
        <div class="h_banner_login_line">
          <div class="h_banner_login_border">
            <img
              class="h_banner_login_li_icon"
              src="@/assets/icon/login_password.png"
            />
          </div>
          <input
            class="h_banner_login_li_input"
            data-type="password"
            placeholder="密码"
            type="password"
            v-model="minilogin['password']"
            @blur="miniloginChange"
            @keyup.enter="func_login"
          />
        </div>
        <div
          class="
            h_banner_login_submit
            
            fontweight-bo
            no-copy
          "
          @click="func_login"
        >
          <!-- 正常状态 -->
          <div v-if="!minilogin.isIng" class="h_banner_login_sub_normal">
            登录
          </div>
          <!-- 登录中状态 -->
          <img
            v-if="minilogin.isIng"
            class="h_banner_login_sub_icon"
            src="@/assets/icon/login_ing.png"
          />
          <div v-if="minilogin.isIng" class="h_banner_login_sub_ing font-14">
            登录中....
          </div>
        </div>
        <div v-if="this.$parent.isorder" class="xincaihang">广东新彩航印刷有限公司</div>
        <div class="h_banner_login_btn">
          <div
            class="
              h_banner_login_btn_view
              font-12
              color-prompt-then
              font-hover
              no-copy
            "
            data-opera="register"
            v-if="this.$parent.isorder"
            @click="func_loginPlate"
          >
            新用户注册
          </div>
          <div
            class="
              h_banner_login_btn_view
              font-12
              color-prompt-then
              font-hover
              no-copy
            "
            data-opera="Retrieve"
            @click="func_loginPlate"
            v-if="this.$parent.isorder"
          >
            忘记密码？
          </div>
        </div>
      </div>
      <div v-if="isLogin" class="h_banner_islogin">
        <div class="h_banner_login_li_toubu">
          <img class="h_banner_login_li_toubu" v-if="this.$parent.isorder"  src="@/assets/icon/toubu.png" />
        </div>
        <div class="h_banner_islo_welcome font-16 color">
          <!-- 头像 -->
          <div class="h_banner_islo_tit_head">
            <img
              class="h_banner_islo_tit_he_img"
              src="@/assets/icon/welcome_head.png"
            />
          </div>
          <div>Hello 欢迎你!</div>
          <div>
            <span>尊贵的</span>
            <!-- <span v-if='userinfo.groupid === 1'  class='color'>(金牌会员)</span>
					<span v-if='userinfo.groupid === 23' class='color'>(代理商)</span>
					<span v-if='userinfo.groupid === 24' class='color'>(盘商)</span>
					<span v-if='userinfo.groupid === 25' class='color'>(VIP会员)</span> -->
            <span v-if="userinfo.groupid === 1" class="color"
              >(超级经销商会员)</span
            >
            <span v-if="userinfo.groupid === 24" class="color"
              >(超级电商会员)</span
            >
            <span v-if="userinfo.groupid === 25" class="color">(金牌会员)</span>
          </div>
        </div>
        <div class="h_banner_islo_title">
          <!-- 用户主体 -->
          <div class="h_banner_islo_tit_content font-16">
            <div class="h_banner_islo_tit_con_view">
              会员号: {{ userinfo.userid }}
            </div>
            <div class="h_banner_islo_tit_con_view">
              公司名: {{ userinfo.company }}
            </div>
          </div>
        </div>
        <div class="h_banner_islo_btn no-copy font-16">
          <div
            class="h_banner_islo_btn_view bgcolor"
            data-opera="mineOrder"
            v-if="this.$parent.isorder"
            @click="func_loginPlate"
          >
            我的订单
          </div>
          <div
            class="h_banner_islo_btn_view bgcolor"
            data-opera="loginOut"
            @click="func_loginPlate"
          >
            退出登录
          </div>
        </div>
      </div>
    </div>

    <!-- 广告产品 -->
    <template v-for="(item, index) in h_second" class="big">
      <div :key="item.id" class="h_second">
        <div class="h_second_title font-20">{{ item.title }}</div>
        <div class="h_second_content">
          <template v-for="(obj, seq) in item['list']">
            <div
              v-if="seq === 0"
              :key="obj.id"
              class="h_second_con_big"
              :data-index="index"
              :data-seq="seq"
              :data-oef="obj.oef"
              @click="func_second_click"
            >
              <img :class="{ h_second_con_big_img: true }" :src="obj.url" />
              <!-- 提示文字 -->
              <!-- <div :class="{'h_second_con_big_prompt font-12':true, 'h_second_con_big_prompt_show':obj.show}">{{obj.prompt}}</div> -->
            </div>
            <div
              v-else
              :key="obj.id"
              class="h_second_con_small"
              :data-index="index"
              :data-seq="seq"
              :data-oef="obj.oef"
              @click="func_second_click"
            >
              <img :class="{ h_second_con_small_img: true }" :src="obj.url" />
              <!-- 提示文字 -->
              <!-- <div :class="{'h_second_con_small_prompt font-12':true, 'h_second_con_small_prompt_show':obj.show}">{{obj.prompt}}</div> -->
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// 图标
// import banner01 from "@/assets/banner/banner_01.jpg";
import banner02 from "@/assets/banner/banner_02.jpg";
import banner03 from "@/assets/banner/banner_03.jpg";
import banner04 from "@/assets/banner/banner_04.jpg";
import banner05 from "@/assets/banner/banner_05.jpg";
import banner06 from "@/assets/banner/banner_06.jpg";
// 一级菜单图标
import cXinfeng from "@/assets/icon/c_xinfeng.png";
import cDanzhang from "@/assets/icon/c_danzhang.png";
import cHongbao from "@/assets/icon/c_hongbao.png";
import cKatao from "@/assets/icon/c_katao.png";
import cQita from "@/assets/icon/c_qita.png";
import cWenjiandai from "@/assets/icon/c_wenjiandai.png";
// 广告图片
import fFirst01 from "@/assets/banner/f_first_01.png";
import fFirst02 from "@/assets/banner/f_first_02.png";
import fFirst03 from "@/assets/banner/f_first_03.png";
import fFirst04 from "@/assets/banner/f_first_04.png";
import fFirst05 from "@/assets/banner/f_first_05.png";
import fFirst06 from "@/assets/banner/f_first_06.png";
import fFirst07 from "@/assets/banner/f_first_07.png";
import fFirst08 from "@/assets/banner/f_first_08.png";

import { req_userLogin, req_validatecode } from "@/services/user";

export default {
  name: "home",
  components: {},
  data() {
    return {
      banners: [
        
        // { id: "hb05", url: banner05, choose: true },
        { id: "hb03", url: banner03, choose: true },
        { id: "hb01", url: banner06, choose: false },
        { id: "hb02", url: banner02, choose: false },
        // { id: "hb06", url: banner01, choose: false },
        { id: "hb04", url: banner04, choose: false },
      ],
      banners_index: 0,
      banIntID: false,
      h_second: [
        {
          title: "信封类",
          list: [
            {
              prompt: "画册印刷",
              url: fFirst01,
              show: false,
              oef: "pidredenv_hbhb",
            },
            {
              prompt: "产品折页",
              url: fFirst02,
              show: false,
              oef: "pidenv_xf",
            },
            {
              prompt: "说明书",
              url: fFirst03,
              show: false,
              oef: "pidredenv_hbhb",
            },
            {
              prompt: "宣传单张",
              url: fFirst04,
              show: false,
              oef: "pidfilepoc_hbwjd",
            },
          ],
        },
        {
          title: "卡套类",
          list: [
            {
              prompt: "利是封",
              url: fFirst05,
              show: false,
              oef: "pidcards_hbfkt",
            },
            {
              prompt: "信封印刷",
              url: fFirst06,
              show: false,
              oef: "pidcards_hbfkt",
            },
            {
              prompt: "档案袋",
              url: fFirst07,
              show: false,
              oef: "pidcards_zbft",
            },
            {
              prompt: "文件袋",
              url: fFirst08,
              show: false,
              oef: "pidcards_hbkzt",
            },
          ],
        },
      ],
      minilogin: {
        username: "",
        password: "",
        isIng: false, //点击状态
      },
      isLogin: false, //是否已登录
      userinfo: {},
    };
  },
  methods: {
    //监听-切换广告
    func_listeningBanners() {
      this.banIntID = setInterval(() => {
        if (this.banners_index < 4) {
          this.banners_index += 1;
          this.banners[this.banners_index - 1]["choose"] = false;
          this.banners[this.banners_index]["choose"] = true;
        } else {
          this.banners_index = 0;
          this.banners[this.banners.length - 1]["choose"] = false;
          this.banners[this.banners_index]["choose"] = true;
        }
      }, 5000);
    },
    func_indicator(event) {
      const index = event.currentTarget.dataset.index;
      if (!this.banners[index]["choose"]) {
        clearInterval(this.banIntID);
        this.banners[this.banners_index]["choose"] = false;
        this.banners_index = parseInt(index);
        this.banners[index]["choose"] = true;
        this.func_listeningBanners();
      }
    },
    func_second_click(event) {
      const index = event.currentTarget.dataset.index;
      const seq = event.currentTarget.dataset.seq;
      const oef = this.h_second[index]["list"][seq]["oef"];
      this.$parent.func_webTab_offerClass(oef);
    },
    // 登录内容输入
    miniloginChange(event) {
      const type = event.currentTarget.dataset.type;
      const value = event.target.value;
      this.minilogin[type] = value;
    },
    // 提交登录
    func_login() {
      if (this.minilogin["isIng"]) return;
      this.minilogin["isIng"] = true;
      setTimeout(async () => {
        if (
          this.minilogin["username"].toString().length < 1 ||
          this.minilogin["password"].toString().length < 1
        ) {
          this.$parent.msgChange("fail", "会员号/手机号不能为空!", "", 3000);
          this.minilogin["isIng"] = false;
          return;
        }
        const result = await req_userLogin(
          this.minilogin["username"],
          this.minilogin["password"]
        );
        this.minilogin["isIng"] = false;
        if (result.success) {
          // 判断用户 !isok||isok=0 用户审核未通过
          if (!result.data["isok"] || result.data["isok"].toString() === "0") {
            this.$parent.confirmChange(
              "warning",
              "账号审核未通过！请联系客服QQ开通",
              () => {},
              () => {},
              { yes: "知道了", no: "" }
            );
          } else {
            this.$parent.msgChange("success", "登录成功", "", 3000);
            // 1) 调用全局登录流程
            this.$parent.func_appLogin(result.data);
            // 2) 通知本页已登录
            this.isLogin = true;
            this.userinfo = result.data;
          }
        } else {
          this.$parent.msgChange("fail", result.msg, "", 3000);
        }
      }, 500);
    },
    // 登录面板其他操作
    func_loginPlate(event) {
      const opera = event.currentTarget.dataset.opera;
      switch (opera) {
        case "register": {
          this.$router.push({
            name: "register",
          });
          break;
        }
        case "Retrieve": {
          this.$router.push({
            name: "Retrieve",
          });
          break;
        }
        case "mineOrder": {
          this.$router.push({
            name: "orderManege",
          });
          break;
        }
        case "loginOut": {
          this.$parent.func_appLoginOut();
          break;
        }
      }
    },
    // 登录面板其他操作
    func_loginPlate1(event) {
      this.$parent.confirmChange(
        "success",
        "注册成功！",
        () => {
          this.$router.push({
            name: "home",
          });
        },
        () => {},
        { yes: "知道了", no: "" },
        "完善信息",
        "tempDownload"
      );
    },
  },
  mounted() {
    this.func_listeningBanners();
    this.isLogin = this.STORAGE.get("g_userInfo");
    this.userinfo = this.isLogin;
    if(!this.$parent.isorder && window.screen.width>=480){
      this.$router.push({
            name: "order",
          });
    }
  },
  destroyed() {
    clearInterval(this.banIntID);
    this.banners_index = 0;
  },
};
</script>
<style src='@/style/home-h5.css' scoped></style>
<style src='@/style/home.css' scoped></style>



// WEBPACK FOOTER //
// src/pages/Home.vue